import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { MORE_ACTIONS_DROPDOWN_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys';

export const MORE_ACTIONS_DROPDOWN_METRIC = createInteractionMetric({
	key: MORE_ACTIONS_DROPDOWN_INTERACTION,
});
